import axios from 'axios'

const base_url = `${process.env.VUE_APP_API_PATH}`;

export default {

    updatePassword(payload) {
        const url = `${base_url}/users/change-password`;

        return axios.put(url, payload)
    },


    addUser(payload) {
        const url = `${base_url}/users`;

        return axios.post(url, payload)
    }


}
